import React from 'react';

export const name = 'flag-DE';

export const FlagDE = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_105)">
      <mask
        id="mask0_2_105"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_105)">
        <path
          d="M0.75 16.1719C1.60243 18.4684 3.13728 20.449 5.14838 21.8477C7.15941 23.2464 9.55036 23.9961 12 23.9961C14.4496 23.9961 16.8406 23.2464 18.8516 21.8477C20.8627 20.449 22.3976 18.4684 23.25 16.1719L12 15.1313L0.75 16.1719Z"
          fill="#FFDA44"
        />
        <path
          d="M12 0C9.54989 0.000299071 7.15861 0.750567 5.14748 2.14997C3.13636 3.54938 1.60179 5.53088 0.75 7.82812L12 8.86875L23.25 7.82812C22.3982 5.53088 20.8636 3.54938 18.8525 2.14997C16.8414 0.750567 14.4501 0.000299071 12 0Z"
          fill="#333333"
        />
        <path
          d="M0.750005 7.82812C-0.250124 10.5195 -0.250124 13.4805 0.750005 16.1719H23.25C24.2505 13.4806 24.2505 10.5194 23.25 7.82812H0.750005Z"
          fill="#D80027"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_105">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
